module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-about js-header-active-color u-relative u-fit-w u-bg--black-near",
    attrs: {
      "data-header-active-color": "white"
    }
  }, [_c('div', {
    staticClass: "p-about__container u-marg-b-xl u-marg-x-auto u-w10of18 u-w7of10@sm"
  }, [_c('router-link', {
    staticClass: "p-about__container__logotype u-absolute u-pos-tl u-w5of10@sm u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('home')
    }
  }, [_c('img', {
    staticClass: "u-fit-w",
    attrs: {
      "src": "/static/medias/images/logotype--gray.png",
      "alt": "Immersive Garden - Logotype",
      "title": "Immersive Garden - Logotype"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "js-title t-text--xl u-color--gray t-ffamily--freight u-uppercase"
  }, [_c('app-text-lines-separated', {
    attrs: {
      "text": _vm.content.title
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "js-first-content u-marg-t-xxxl t-text--sm t-fweight--light u-color--gray-dark",
    domProps: {
      "innerHTML": _vm._s(_vm.content.first_content)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "u-marg-t-xxxl t-text--md t-fweight--light u-color--gray u-uppercase",
    domProps: {
      "innerHTML": _vm._s(_vm.content.second_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xl u-flex u-flex-fw--wrap u-flex-jc--space-between"
  }, _vm._l((_vm.content.list), function(item, index) {
    return _c('ul', {
      staticClass: "p-about__pole-column o-list--none u-marg-t-xl u-w1of3"
    }, [_c('h4', {
      staticClass: "t-text--xs-l u-color--gray u-uppercase",
      domProps: {
        "innerHTML": _vm._s(item.value.title)
      }
    }), _vm._v(" "), _vm._l((item.value.list), function(label, i) {
      return _c('li', {
        staticClass: "p-about__pole-row t-text--sm u-color--gray-dark",
        domProps: {
          "innerHTML": _vm._s(label.value)
        }
      })
    })], 2)
  })), _vm._v(" "), _c('p', {
    staticClass: "u-marg-t-xxxl t-text--sm t-fweight--light u-color--gray-dark",
    domProps: {
      "innerHTML": _vm._s(_vm.content.second_content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xxxl"
  }, [_c('h4', {
    staticClass: "t-text--xs-l u-color--gray u-uppercase",
    domProps: {
      "innerHTML": _vm._s(_vm.content.recognitions_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex u-flex-fw--wrap"
  }, _vm._l((_vm.recognitions), function(column, index) {
    return _c('ul', {
      staticClass: "p-about__recognitions-column o-list--none"
    }, _vm._l((column), function(row, i) {
      return _c('li', {
        staticClass: "p-about__recognitions-row t-fweight--light t-text--sm u-color--gray-dark",
        domProps: {
          "innerHTML": _vm._s(row.text)
        }
      })
    }))
  }))]), _vm._v(" "), _c('div', {
    staticClass: "p-about__contacts-mobile js-contact-mobile"
  }, [_c('div', {
    staticClass: "p-about__line u-marg-y-xl u-bg--white-near u-opacity--12"
  }), _vm._v(" "), _vm._l((_vm.content.contacts), function(contact, index) {
    return _c('div', {
      staticClass: "p-about__contacts-mobile__item"
    }, [_c('a', {
      staticClass: "t-link u-relative u-inline-block u-click-area-xxs",
      attrs: {
        "href": 'mailto:' + contact.value.mail,
        "target": "_blank",
        "rel": "nofollow noreferrer noopener"
      }
    }, [_c('h4', {
      staticClass: "t-text--xs-l u-color--gray u-uppercase",
      domProps: {
        "innerHTML": _vm._s(contact.value.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "u-marg-t-xxxs u-inline-block t-text--xs2 t-lspacing--x-small u-color--gray-dark",
      domProps: {
        "innerHTML": _vm._s(contact.value.mail)
      }
    })])])
  }), _vm._v(" "), _c('app-newsletter', {
    staticClass: "u-marg-t-md u-w1of2 u-fit-w@sm"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "p-about__informations-mobile u-marg-t-xl"
  }, [_c('a', {
    staticClass: "u-relative t-link u-inline-block u-click-area-xxs",
    attrs: {
      "href": "https://goo.gl/maps/xQJnhd9ihVr",
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_c('h4', {
    staticClass: "t-text--xs2 t-lspacing--x-small u-color--gray",
    domProps: {
      "innerHTML": _vm._s(_vm.content.address_name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xxs t-text--xs2 t-lspacing--x-small u-color--gray-dark",
    domProps: {
      "innerHTML": _vm._s(_vm.content.address_address)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "u-relative u-marg-t-xxs t-link u-inline-block u-click-area-xxs",
    attrs: {
      "href": 'tel:' + _vm.content.address_phone,
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_c('div', {
    staticClass: "t-text--xs2 t-lspacing--x-small u-color--gray-dark",
    domProps: {
      "innerHTML": _vm._s(_vm.content.address_phone)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-sm t-text--xs2 t-lspacing--x-small u-color--gray-dark"
  }, _vm._l((_vm.content.social_links), function(link, index) {
    return _c('span', {
      staticClass: "u-marg-t-xxs@sm u-block@sm"
    }, [_c('a', {
      staticClass: "t-link",
      attrs: {
        "href": link.value.url,
        "target": "_blank",
        "rel": "noopener noreferrer nofollow"
      },
      domProps: {
        "innerHTML": _vm._s(link.value.label)
      }
    }), _vm._v(" "), (index < _vm.content.social_links.length - 1) ? _c('span', {
      staticClass: "u-marg-x-xxs u-hide@sm"
    }, [_vm._v("/")]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "p-about__right-side u-fixed u-pos-tr u-w2of10 u-fit-vh"
  }, [_c('div', {
    staticClass: "p-about__right-side__contact u-absolute u-click-area-xxs u-cursor-pointer",
    on: {
      "click": _vm._clickOnButtonContactUs
    }
  }, [_c('span', {
    staticClass: "t-text--xs-l t-text--nowrap t-fweight--bold u-color--gray-dark u-uppercase"
  }, [_vm._v("Contact Us")])]), _vm._v(" "), _c('div', {
    staticClass: "p-about__right-side__back-to-top u-absolute u-click-area-xxs u-cursor-pointer",
    class: [_vm.buttonBackToTopIsVisible ? 'is-visible' : 'is-hidden'],
    on: {
      "click": _vm._clickOnButtonBackToTop
    }
  }, [_c('img', {
    staticClass: "u-fit-h u-opacity--36",
    attrs: {
      "src": "/static/medias/images/arrow-up--white.png",
      "alt": "Back to top",
      "title": "Back to top"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-about__contacts js-contacts-container u-fixed"
  }, [_vm._l((_vm.content.contacts), function(contact, index) {
    return _c('div', {
      staticClass: "p-about__contacts__item"
    }, [_c('a', {
      staticClass: "t-link u-relative u-inline-block u-click-area-xxs",
      attrs: {
        "href": 'mailto:' + contact.value.mail,
        "target": "_blank",
        "rel": "nofollow noreferrer noopener"
      }
    }, [_c('h4', {
      staticClass: "t-text--xs-l u-color--gray u-uppercase",
      domProps: {
        "innerHTML": _vm._s(contact.value.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "p-about__contacts__item__mail u-marg-t-xxxs u-inline-block t-text--xs2 t-lspacing--x-small u-color--gray",
      domProps: {
        "innerHTML": _vm._s(contact.value.mail)
      }
    })])])
  }), _vm._v(" "), _c('app-newsletter', {
    staticClass: "u-marg-t-md u-fit-w u-pad-r-w2of10"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "p-about__informations js-informations-container u-fixed"
  }, [_c('a', {
    staticClass: "u-relative t-link u-inline-block u-click-area-xxs",
    attrs: {
      "href": "https://goo.gl/maps/xQJnhd9ihVr",
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_c('h4', {
    staticClass: "t-text--xs2 t-lspacing--x-small u-color--gray",
    domProps: {
      "innerHTML": _vm._s(_vm.content.address_name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xxxs t-text--xs2 t-lspacing--x-small u-color--gray-dark",
    domProps: {
      "innerHTML": _vm._s(_vm.content.address_address)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "p-about__informations__phone u-relative u-marg-t-xxs t-link u-inline-block u-click-area-xxs u-color--gray",
    attrs: {
      "href": 'tel:' + _vm.content.address_phone,
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_c('span', {
    staticClass: "t-text--xs2 t-lspacing--x-small",
    domProps: {
      "innerHTML": _vm._s(_vm.content.address_phone)
    }
  })]), _vm._v(" "), (_vm.content.social_links.length > 0) ? _c('div', {}, [_c('div', {
    staticClass: "p-about__informations__separator u-marg-y-xs u-w6of10 u-bg--gray-dark u-opacity--50"
  }), _vm._v(" "), _c('ul', {
    staticClass: "o-list--none"
  }, _vm._l((_vm.content.social_links), function(link, index) {
    return _c('li', {
      staticClass: "u-marg-t-xxs@sm u-block@sm t-text--xs2 t-lspacing--x-small u-color--gray-dark"
    }, [_c('a', {
      staticClass: "t-link",
      attrs: {
        "href": link.value.url,
        "target": "_blank",
        "rel": "noopener noreferrer nofollow"
      },
      domProps: {
        "innerHTML": _vm._s(link.value.label)
      }
    })])
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63fc6312"}!./src/scripts/components/page-about/template.html
// module id = 143
// module chunks = 0